export default __webpack_public_path__ + "static/media/pic8.3e521838.png";